/* eslint-disable @typescript-eslint/no-explicit-any */

type ObjectKeys<T> = T extends Record<string, any>
    ? (keyof T)[]
    : T extends number
    ? []
    : T extends Array<any> | string
    ? string[]
    : never;

/**
 * Расширяем методы глобальных объектов
 */

// Собирает составной тип из ключей объекта, а не просто возвращает string
interface ObjectConstructor {
    keys<T>(o: T): ObjectKeys<T>;
}

// Проверяет вхождение подтипа более мягко по сравнению с дефолтным поведением
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Array<T> {
    includes(searchElement: unknown, fromIndex?: number): boolean;
}

// Проверяет вхождение подтипа для `[...] as const` более мягко по сравнению с дефолтным поведением
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface ReadonlyArray<T> {
    includes(searchElement: unknown, fromIndex?: number): boolean;
}
